import { Box, Typography } from '@mui/material';

import { DASH } from '../tokens';
import { buildDomainSegments, type DomainLevelCounts } from '../domainBars';

export interface StackedDomainBarProps {
  domain: string;
  counts: DomainLevelCounts;
}

export function StackedDomainBar({ domain, counts }: StackedDomainBarProps) {
  const segments = buildDomainSegments(counts);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Typography
        component="div"
        sx={{
          flex: '0 0 auto',
          minWidth: '80px',
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '24px',
          color: DASH.ink,
        }}
      >
        {domain}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '24px',
          borderRadius: '4px',
          overflow: 'hidden',
          bgcolor: DASH.trackBg,
        }}
      >
        {segments.map((segment) => (
          <Box
            key={segment.key}
            aria-hidden
            sx={{ flexGrow: segment.count, bgcolor: segment.color }}
          />
        ))}
      </Box>
    </Box>
  );
}
